/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import './LogoutBanner.scss';

import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

export const LogoutBanner = ({ title, body }) => (
  <div className="logout-banner">
    <h2 className="logout-banner-title">{title}</h2>
    <div className="body">{body}</div>
  </div>
);

const mapStateToProps = (state) => ({
  accounts: state.accounts
});

export default withRouter(connect(mapStateToProps)(LogoutBanner));
